// extracted by mini-css-extract-plugin
export var month = "sub-module--month--9181a";
export var newcost = "sub-module--newcost--c8e53";
export var sub = "sub-module--sub--497d6";
export var sub__description = "sub-module--sub__description--78a9d";
export var sub__inner = "sub-module--sub__inner--8ec81";
export var sub__item = "sub-module--sub__item--53d41";
export var sub__itemList = "sub-module--sub__item--list--ff9fd";
export var sub__title = "sub-module--sub__title--f72b0";
export var sub__widget = "sub-module--sub__widget--f8093";
export var trial = "sub-module--trial--c583c";
export var trial__cost = "sub-module--trial__cost--d281b";
export var trial__txt = "sub-module--trial__txt--7852c";